import { AddressView } from '../views/address';
import { EcardSendView } from '../views/ecard-editor/ecard-editor';
import { EditorView } from '../views/editor';
import { PreviewView } from '../views/preview';
import { SelectEnvelopeView } from '../views/select-envelope/select-envelope';

export const PODRoutes = [
  {
    name: 'Editor',
    route: '/create/:productId',
    view: EditorView,
  },
  {
    name: 'Editor',
    route: '/edit/:projectId',
    view: EditorView,
  },
  {
    name: 'Envelope',
    route: '/envelope',
    view: SelectEnvelopeView,
  },
  {
    name: 'Address',
    route: '/address',
    view: AddressView,
  },
  {
    name: 'Ecard',
    route: '/ecard-send',
    view: EcardSendView,
  },
  {
    name: 'Preview',
    route: '/preview',
    view: PreviewView,
  },
];
